import { Component, Input } from '@angular/core';

@Component({
  selector: 'tax-transaction-report-totals',
  templateUrl: 'transaction-report-totals.component.html',
  styleUrls: ['transaction-report-totals.component.sass'],
})

export class TransactionReportTotalsComponent {
  // @ts-ignore
  @Input() transactionTotalResult;
}
